/* dev-blog-preview.js */

(function () {
  function init(section) {
    const track = section.querySelector('[data-cards-track]');
    const progressFill = section.querySelector('[data-scroll-progress]');

    if (!track || !progressFill) return;

    const cards = track.children;
    const total = cards.length;
    if (total < 2) return;

    function updateProgress() {
      if (track.scrollWidth <= track.clientWidth) {
        progressFill.style.width = '0%';
        return;
      }
      const gap = parseFloat(getComputedStyle(track).gap) || 8;
      const cardWidth = cards[0].offsetWidth + gap;
      const visibleCount = Math.max(1, Math.round(track.clientWidth / cardWidth));
      const index = Math.round(track.scrollLeft / cardWidth);
      const pct = ((index + visibleCount) / total) * 100;
      progressFill.style.width = `${Math.min(100, pct)}%`;
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.blog-preview').forEach(section => init(section));
  });
}());
